export default function() {
    return {

        calculateClientPrice(price, tax, type, settings, currency) {
            return this.priceToString(this.calculateClientPriceValue(price, tax, type, settings, currency), currency.currency.symbol);
        },

        calculateClientPriceValue(price, tax, type, settings, currency) {

            if (settings.B2B_CLIENT_PRICE == 'origin') {
                return this.calculatePriceValue(price, tax, type, settings, currency);
            } else {
                let margin = price;
                if(settings.B2B_CLIENT_MARGIN_TYPE  == 'percent') {
                    margin = price + ((price * settings.B2B_CLIENT_MARGIN) /100);
                } else {
                    margin = price + Number(settings.B2B_CLIENT_MARGIN);
                    if (margin < 0 ) {
                        margin = 0;
                    }
                }


                return this.calculatePriceValue(margin, tax, type, settings, currency);
            }
        },


        calculateClientOfferTaxString(price, tax, quantity, currency, markupType, markupValue) {
            return this.priceToString(
                this.calculateClientOfferTax(price, tax, quantity, currency, markupType, markupValue),
                currency.currency.symbol
            );
        },

        calculateClientOfferTax(price, tax, quantity, currency, markupType, markupValue) {
            return this.calculateClientOfferPrice(price, tax, quantity, 'gross', currency, markupType, markupValue)
                - this.calculateClientOfferPrice(price, tax, quantity, 'net', currency, markupType, markupValue);
        },

        calculateClientOfferPriceString(price, tax, quantity, resultType, currency, markupType, markupValue) {
            return this.priceToString(
                this.calculateClientOfferPrice(price, tax, quantity, resultType, currency, markupType, markupValue),
                currency.currency.symbol
            );
        },

        calculateClientOfferPrice(price, tax, quantity, resultType, currency, markupType, markupValue) {
            if(markupType  == 'percent') {
                let markup = price + ((price * markupValue) /100);
                return this.calculateOfferPrice(markup, tax, quantity, resultType, currency);
            }
            let markup = price + Number(markupValue);
            if (markup < 0 ) {
                markup = 0;
            }
            return this.calculateOfferPrice(markup, tax, quantity, resultType, currency);
        },

        calculateOfferPrice(price, tax, quantity, resultType, currency) {
            return this.calculateCurrency(this.calculateOfferTypePrice(price, tax, resultType), currency.value) * quantity;
        },

        calculateOfferTypePrice(price, tax, resultType) {
            if(resultType == 'net') {
                return price
            } else {
                return this.calculateGrossPrice(price, tax);
            }
        },

        calculatePriceValue(price, tax, type, settings, currency) {
            return this.calculateCurrency(this.calculateTypePrice(price, tax, type, settings), currency.value);
        },

        calculatePrice(price, tax, type, settings, currency) {
            return this.priceToString(this.calculatePriceValue(price, tax, type, settings, currency), currency.currency.symbol);
        },

        calculateTypePrice(price, tax, type, settings) {
            if (settings.B2B_CLIENT_PRICE_TYPE == type) {
                return price;
            } else {
                if(settings.B2B_CLIENT_PRICE_TYPE == 'net') {
                    return this.calculateNetPrice(price, tax);
                } else {
                    return this.calculateGrossPrice(price, tax);
                }
            }
        },

        calculateNetPrice(price, tax) {
            return  Math.round((100 * price / (100+tax))*100)/100;
        },

        calculateGrossPrice(price, tax) {
            return  Math.round(price * (100+tax))/100;
        },

        calculateCurrency(price, currencyValue){
            return price / currencyValue;
        },

        priceToString(value, symbol) {
            let val = (value/1).toFixed(2).replace('.', ',');
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' ' + symbol;
        },

        priceTypeName(settings) {
            return settings.B2B_CLIENT_PRICE_TYPE == 'net' ? 'netto'  : 'brutto';
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/products/src/product/CalculatePrice.js